// reducers
import { Location } from 'history'
import { produce } from 'immer'
import React from 'react'
import AgentReducer, {
  Actions as AgentActions,
  AgentState,
  initialState as initialAgentState,
} from 'src/agent/redux/agent.reducer'
import AccountReducer, {
  AccountState,
  Actions as AccountActions,
  initialState as initialAccountState,
} from 'src/app/Account/redux/account.reducer'
import AccountsReducer, {
  AccountsState,
  Actions as AccountsActions,
  initialState as initialAccountsState,
} from 'src/app/Accounts/redux/accounts.reducer'
import AddExpenseReducer, {
  Actions as AddExpenseActions,
  AddExpenseState,
  initialState as initialAddExpenseState,
} from 'src/app/AddExpenseFlyout/redux/addExpense.reducer'
import {
  GetAlertStatusSuccessAction,
  SET_ALERT_STATUS_SUCCESS,
  SET_DOWNGRADE_BAR_VISIBLE,
  SetIsDowngradeBarVisibleAction,
} from 'src/app/AlertBar/redux/alertBar.actions'
import BudgetReducer, {
  Actions as BudgetActions,
  BudgetState,
  initialState as initialBudgetState,
} from 'src/app/Budget/redux/budget.reducer'
import BudgetsReducer, {
  Actions as BudgetsActions,
  BudgetsState,
  initialState as initialBudgetsState,
} from 'src/app/Budgets/redux/budgets.reducer'
import BudgetRequestReducer, {
  Actions as BudgetRequestActions,
  BudgetRequestsState as BudgetRequestState,
  initialState as initialBudgetRequestState,
} from 'src/app/BudgetsRequests/redux/budgetRequest.reducer'
import BusinessRulesReducer, {
  Actions as BusinessRulesActions,
  BusinessRulesState,
  initialState as initialBusinessRulesState,
} from 'src/app/BusinessRules/redux/businessRules.reducer'
import CloseAccountContentReducer, {
  Actions as CloseAccountActions,
  CloseAccountContentState,
  initialState as initialCloseAccountState,
} from 'src/app/CloseAccountContent/redux/closeAccountContent.reducer'
import CloseVirtualCardContentReducer, {
  Actions as CloseVirtualCardActions,
  CloseVirtualCardContentState,
  initialState as initialCloseVirtualCardState,
} from 'src/app/CloseVirtualCardContent/redux/closeVirtualCardContent.reducer'
import CreateBudgetReducer, {
  Actions as CreateBudgetActions,
  CreateBudgetState,
  initialState as initialCreateBudgetState,
} from 'src/app/CreateBudget/redux/createBudget.reducer'
import CreatOrgIntegrationReducer, {
  Actions as CreateOrgIntegrationActions,
  CreateOrgIntegrationState,
  initialState as initialCreatOrgIntegrationState,
} from 'src/app/CreateOrgIntegration/redux/createOrgIntegration.reducer'
import CreateVirtualCardFormReducer, {
  Actions as CreateVirtualCardActions,
  CreateVirtualCardState,
  initialState as initialCreateVirtualCardState,
} from 'src/app/CreateVirtualCardForm/redux/createVirtualCardForm.reducer'
import CspSigninReducer, {
  Actions as CspSigninActions,
  CspSigninState,
  initialState as initialCspSigninState,
} from 'src/app/CspSignin/redux/cspSignin.reducer'
import CspUserDetailReducer, {
  Actions as CspUserDetailActions,
  CspUserDetailState,
  initialState as initialCspUserDetailState,
} from 'src/app/CspUserDetail/redux/cspUserDetailReducer'
import DeactivateBudgetReducer, {
  Actions as DeactivateBudgetActions,
  DeactivateBudgetState,
  initialState as initialDeactivateBudgetState,
} from 'src/app/DeactivateBudget/redux/deactivateBudget.reducer'
import DeactivateVirtualCardContentReducer, {
  Actions as DeactivateVirtualCardActions,
  DeactivateVirtualCardContentState,
  initialState as initialDeactivateVirtualCardState,
} from 'src/app/DeactivateVirtualCardContent/redux/deactivateVirtualCardContent.reducer'
import ExpenseReportReducer, {
  Actions as ExpenseReportActions,
  ExpenseReportState,
  initialState as initialExpenseReportState,
} from 'src/app/ExpenseReport/redux/expenseReport.reducer'
import CoreExpenseReportsReducer, {
  Actions as ExpenseReportsActions,
  ExpenseReportsState,
  initialState as initialExpenseReportsState,
} from 'src/app/Expenses/redux/expenses.reducer'
import HomeReducer, {
  Actions as HomeActions,
  HomeState,
  initialState as initialHomeState,
} from 'src/app/Home/redux/home.reducer'
import InvitePeopleReducer, {
  Actions as InvitePeopleActions,
  initialState as initialInvitePeopleState,
  InvitePeopleState,
} from 'src/app/InvitePeople/redux/invitePeople.reducer'
import ManageOrgIntegrationReducer, {
  Actions as ManageOrgIntegrationActions,
  initialState as initialManageOrgIntegrationState,
  ManageOrgIntegrationState,
} from 'src/app/ManageOrgIntegration/redux/manageOrgIntegrationPopup.reducer'
import NotificationsReducer, {
  Actions as NotificationsActions,
  initialState as initialNotificationsState,
  NotificationsState,
} from 'src/app/Notifications/redux/notifications.reducer'
import OrganizationInfoReducer, {
  Actions as OrganizationInfoActions,
  initialState as initialOrganizationInfoState,
  OrganizationInfoState,
} from 'src/app/OrganizationInfo/redux/organizationInfo.reducer'
import OrgIntegrationReducer, {
  Actions as OrgIntegrationsActions,
  initialState as initialGetOrgIntegrationsState,
  OrgIntegrationState as OrgIntegrationsState,
} from 'src/app/OrganizationIntegrations/redux/organizationIntegrations.reducers'
import OrganizationInvitesReducer, {
  Actions as OrganizationInvitesActions,
  initialState as initialOrganizationInvitesState,
  OrganizationInvitesState,
} from 'src/app/OrganizationInvites/redux/organizationInvites.reducer'
import PeopleReducer, {
  Actions as PeopleActions,
  initialState as initialPeopleState,
  PeopleState,
} from 'src/app/People/redux/people.reducer'
import PeopleDetailReducer, {
  Actions as PeopleDetailActions,
  initialState as initialPeopleDetailFlyoutState,
  PeopleDetailFlyoutState,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.reducer'
import ProfileReducer, {
  Actions as ProfileActions,
  initialState as initialProfileState,
  ProfileState,
} from 'src/app/Profile/redux/profile.reducer'
import ProfileSecurityReducer, {
  Actions as ProfileSecurityActions,
  initialState as initialProfileSecurityState,
  ProfileSecurityState,
} from 'src/app/ProfileSecurity/redux/profileSecurity.reducer'
import RegisterAccountReducer, {
  Actions as RegisterAccountActions,
  initialState as initialRegisterAccountState,
  RegisterAccountState,
} from 'src/app/RegisterAccount/redux/registerAccount.reducer'
import RequestBudgetReducer, {
  Actions as RequestBudgetActions,
  initialState as initialRequestBudgetState,
  RequestBudgetState,
} from 'src/app/RequestBudget/redux/requestBudget.reducer'
import RequestVirtualCardReducer, {
  Actions as RequestVirtualCardActions,
  initialState as initialRequestVirtualCardState,
  RequestVirtualCardState,
} from 'src/app/RequestVirtualCard/redux/requestVirtualCard.reducer'
import ResetPasswordReducer, {
  Actions as ResetPasswordActions,
  initialState as initialResetPasswordState,
  ResetPasswordState,
} from 'src/app/ResetPassword/redux/resetPassword.reducer'
import ScreenVirtualCardReducer, {
  Actions as ScreenVirtualCardActions,
  initialState as initialScreenVirtualCardState,
  ScreenVirtualCardState,
} from 'src/app/ScreenVirtualCard/redux/screenVirtualCard.reducer'
import SearchReducer, {
  Actions as SearchActions,
  initialState as initialSearchState,
  SearchState,
} from 'src/app/Search/redux/search.reducer'
import SigninReducer, {
  Actions as SigninActions,
  initialState as initialSigninState,
  SigninState,
} from 'src/app/Signin/redux/signin.reducer'
import SignupReducer, {
  Actions as SignupActions,
  initialState as initialSignupState,
  SignupState,
} from 'src/app/Signup/redux/signup.reducer'
import ToastReducer, {
  Actions as ToastActions,
  initialState as initialToastState,
  ToastState,
} from 'src/app/Toast/redux/toast.reducer'
import TransactionDetailReducer, {
  Actions as TransactionDetailActions,
  initialState as initialTransactionDetailState,
  TransactionDetailState,
} from 'src/app/TransactionDetail/redux/transactionDetail.reducer'
import TransactionsReducer, {
  Actions as TransactionsActions,
  initialState as initialTransactionsState,
  TransactionsState,
} from 'src/app/Transactions/redux/transactions.reducer'
import UpdateBudgetReducer, {
  Actions as UpdateBudgetActions,
  initialState as initialUpdateBudgetState,
  UpdateBudgetState,
} from 'src/app/UpdateBudget/redux/updateBudget.reducer'
import CoreUpdateExpenseReducer, {
  Actions as UpdateExpenseActions,
  initialState as initialUpdateExpenseState,
  UpdateExpenseState,
} from 'src/app/UpdateExpenseFlyout/redux/updateExpense.reducer'
import UpdateProfilePhotoReducer, {
  Actions as UpdateProfilePhotoActions,
  initialState as initialUpdateProfilePhotoState,
  UpdateProfilePhotoState,
} from 'src/app/UpdateProfilePhoto/redux/updateProfilePhoto.reducer'
import UpdateVirtualCardReducer, {
  Actions as UpdateVirtualCardActions,
  initialState as initialUpdateVirtualCardState,
  UpdateVirtualCardState,
} from 'src/app/UpdateVirtualCardForm/redux/updateVirtualCardForm.reducer'
import CoreReceiptsAutoMatchReducer, {
  Actions as ReceiptsAutoMatchActions,
  initialState as initialReceiptsAutoMatchState,
  ReceiptsAutoMatchState,
} from 'src/app/UploadReceiptsAutoMatchPopup/redux/uploadReceiptsAutoMatch.reducers'
import VirtualCardDetailReducer, {
  Actions as VirtualCardDetailActions,
  initialState as initialVirtualCardDetailState,
  VirtualCardDetailState,
} from 'src/app/VirtualCardDetail/redux/virtualCardDetail.reducer'
import VirtualCardsReducer, {
  Actions as VirtualCardsActions,
  initialState as initialVirtualCardsState,
  VirtualCardsState,
} from 'src/app/VirtualCards/redux/virtualCards.reducer'
import DownloadTransactionsReducer, {
  Actions as DownloadTransactionsActions,
  DownloadTransactionsState,
  initialState as initialDownloadTransactionsState,
} from 'src/component-modal/DownloadTransactionsModal/redux/downloadTransactions.reducer'
import { OrganizationConnectedPlatform } from 'src/enums'
import { APIKey } from 'src/models/apiKey.models'
import { OrgExpenseReportConfirmDateChangePopupProps } from 'src/models/orgExpenseReports.models'
import { ReceiptAttachmentModel } from 'src/models/receiptAttachment.models'
import { UserListModel } from 'src/models/user.models'
import {
  RESET_APP_STATE,
  ResetAppStateAction,
  SET_CONFIRM_ORG_EXPENSE_REPORT_DATE_CHANGE_POPUP,
  SET_IS_ACKNOWLEDGEMENT_ALERT_BAR_OPEN,
  SET_IS_ADD_DEPT_POPUP_OPEN,
  SET_IS_ADD_MISSING_INFORMATION_EXPENSE_REPORT_POPUP_OPEN,
  SET_IS_ADD_SECONDARY_EMAIL_POPUP_OPEN,
  SET_IS_API_KEY_CREATED_POPUP_OPEN,
  SET_IS_ATTACHMENT_POPUP_OPEN,
  SET_IS_BMO_WELCOME_POPUP_OPEN,
  SET_IS_BRAND_REDIRECT_POPUP_OPEN,
  SET_IS_BULK_CLOSE_VIRTUAL_CARDS_POPUP_OPEN,
  SET_IS_BULK_DEACTIVATE_VIRTUAL_CARDS_POPUP_OPEN,
  SET_IS_BULK_UPDATE_VIRTUAL_CARDS_FLYOUT_OPEN,
  SET_IS_CANCEL_ORG_INVITE_POPUP_OPEN,
  SET_IS_CHOOSE_2FA_METHOD_POPUP_OPEN,
  SET_IS_CREATE_EXPENSE_REPORT_POPUP_OPEN,
  SET_IS_CREATE_ORG_INTEGRATION_POPUP_OPEN,
  SET_IS_DELETE_ACCOUNT_POPUP_OPEN,
  SET_IS_DELETE_API_KEY_POPUP_OPEN,
  SET_IS_DELETE_EXPENSE_POPUP_OPEN,
  SET_IS_DELETE_EXPENSE_REPORTS_POPUP_OPEN,
  SET_IS_DOWNLOAD_EXPENSE_REPORTS_PAID_POPUP_OPEN,
  SET_IS_DOWNLOAD_SUCCESS_POPUP_OPEN,
  SET_IS_EXTRA_VERIFICATION_POPUP_OPEN,
  SET_IS_FILTERS_FLYOUT_OPEN,
  SET_IS_MANAGE_ORG_INTEGRATION_POPUP_OPEN,
  SET_IS_MARK_EXPENSE_REPORTS_PAID_POPUP_OPEN,
  SET_IS_MOBILE_WEB_POPUP_OPEN,
  SET_IS_ORG_OWNER_REASSIGNMENT_POPUP_OPEN,
  SET_IS_REMOVE_BUDGET_USER_POPUP_OPEN,
  SET_IS_REQUEST_COMPLETED_POPUP_OPEN,
  SET_IS_SEND_RECEIPT_REMINDER_POPUP_OPEN,
  SET_IS_SESSION_EXPIRING_POPUP_OPEN,
  SET_IS_SETUP_ORGANIZATION_POPUP_OPEN,
  SET_IS_SIDENAV_LOCKED_OPEN,
  SET_IS_SIDENAV_OPEN,
  SET_IS_SUBMIT_EXPENSE_REPORT_POPUP_OPEN,
  SET_IS_SYNC_TRANSACTIONS_POPUP_OPEN,
  SET_IS_TOOLTIP_POPUP_OPEN,
  SET_IS_UPLOAD_RECEIPTS_AUTO_MATCH_POPUP_OPEN,
  SET_IS_WHATS_NEW_POPUP_OPEN,
  SET_SHOW_SIDENAV_LARGE,
  SetConfirmOrgExpenseReportDateChangePopupAction,
  SetFiltersFlyoutOpenAction,
  SetIsAcknowledgementAlertBarOpenAction,
  SetIsAddAPIKeyPopupOpenAction,
  SetIsAddDeptPopupOpenAction,
  SetIsAddMissingInformationExpenseReportPopupOpenAction,
  SetIsAddSecondaryEmailPopupOpenAction,
  SetIsAttachmentPopupOpenAction,
  SetIsBmoWelcomePopupOpenAction,
  SetIsBrandRedirectPopupOpenAction,
  SetIsBulkCloseVirtualCardsPopupOpenAction,
  SetIsBulkDeactivateVirtualCardsPopupOpenAction,
  SetIsBulkUpdateVirtualCardsFlyoutOpenAction,
  SetIsCancelOrgInvitePopupOpenAction,
  SetIsChoose2faMethodPopupOpenAction,
  SetIsCreateExpenseReportPopupOpenAction,
  SetIsCreateOrgIntegrationOpenAction,
  SetIsDeleteAccountPopupOpenAction,
  SetIsDeleteAPIKeyPopupOpenAction,
  SetIsDeleteExpensePopupOpenAction,
  SetIsDeleteExpenseReportsPopupOpenAction,
  SetIsDownloadExpenseReportsPaidPopupOpenAction,
  SetIsDownloadSuccessPopupOpenAction,
  SetIsExtraVerificationPopupOpenAction,
  SetIsManageOrgIntegrationPopupOpenAction,
  SetIsMarkExpenseReportsPaidPopupOpenAction,
  SetIsMobileWebPopupOpenAction,
  SetIsOrgOwnerReassignmentPopupOpenAction,
  SetIsRemoveBudgetUserPopupOpenAction,
  SetIsRequestCompletedPopupOpenAction,
  SetIsSendReceiptReminderPopupOpenAction,
  SetIsSessionExpiringPopupOpenAction,
  SetIsSetupOrganizationPopupOpenAction,
  SetIsSidenavLockedOpenAction,
  SetIsSidenavOpenAction,
  SetIsSubmitExpenseReportPopupOpenAction,
  SetIsSyncTransactionsPopupOpenAction,
  SetIsTooltipPopupOpenAction,
  SetIsUploadReceiptsAutoMatchPopupOpenAction,
  SetIsWhatsNewPopupOpenAction,
  SetShowSidenavLargeAction,
} from 'src/redux/actions/app.actions'
import { GetBudgetRequestsActions } from 'src/redux/actions/data/budgetRequests.actions'
import { LocationState } from 'src/redux/createRootReducer'

export interface AppBaseState {
  showSidenavLarge: boolean
  isSidenavOpen: boolean
  isSidenavLockedOpen: boolean
  isAlertBarOpen: boolean
  isDowngradeBarOpen: boolean
  alertMessage?: string
  isSessionExpiringPopupOpen: boolean
  isTooltipPopupOpen: boolean
  tooltipPopupMessage?: React.ReactNode
  isAttachmentPopupOpen: boolean
  deleteAction?: () => void
  attachment?: ReceiptAttachmentModel
  peopleMember?: UserListModel
  messageCount?: number
  isRemoveUserFromOrganizationPopupOpen: boolean
  isCancelOrgInvitePopupOpen: boolean
  isCreateOrgIntegrationOpen: boolean
  createOrgIntegrationIntegrationType?: OrganizationConnectedPlatform
  isManageOrgIntegrationPopupOpen: boolean
  isDeactivateBudgetPopupOpen: boolean
  isOrgOwnerReassignmentPopupOpen: boolean
  isOrgOwnerReassignment: boolean
  deletePersonPopupMessage?: React.ReactNode
  isBmoWelcomePopupOpen: boolean
  isBrandSpecificWelcomePopupOpen: boolean
  isSendReceiptReminderPopupOpen: boolean
  isCreateExpenseReportPopupOpen: boolean
  isMarkExpenseReportsPaidPopupOpen: boolean
  isDownloadExpenseReportsPaidPopupOpen: boolean
  isDownloadSuccessPopupOpen: boolean
  isDeleteExpensePopupOpen: boolean
  isDeleteExpenseReportsPopupOpen: boolean
  isWhatsNewPopupOpen: boolean
  isAcknowledgementAlertBarOpen: boolean
  isSetupOrganizationPopupOpen: boolean
  confirmOrgContinueLocation?: string | Location<LocationState>
  isSubmitExpenseReportPopupOpen: boolean
  isSyncTransactionsPopupOpen: boolean
  isAddMissingInformationExpenseReportPopupOpen: boolean
  isUploadReceiptsAutoMatchPopupOpen: boolean
  isRemoveBudgetUserPopupOpen: boolean
  isMobileWebPopupOpen: boolean
  isRequestCompletedPopupOpen: boolean
  isBulkDeactivateVirtualCardsPopupOpen: boolean
  isBulkCloseVirtualCardsPopupOpen: boolean
  isBulkUpdateVirtualCardsFlyoutOpen: boolean
  isAddSecondaryEmailPopupOpen: boolean
  isFiltersFlyoutOpen: boolean
  confirmOrgExpenseReportDateChangePopupProps:
    | OrgExpenseReportConfirmDateChangePopupProps
    | undefined
  isExtraVerificationPopupOpen: boolean
  isChoose2faMethodPopupOpen: boolean
  isAddDeptPopupOpen: boolean
  isAPIKeyCreatedPopupOpen: boolean
  apiKeyCreatedAPIKey?: APIKey
  isDeleteAPIKeyPopupOpen: boolean
  deleteAPIKeyId?: string
  deleteAPIKeyExpiresAt?: string
  isBrandRedirectPopupOpen: boolean
}

export const initialBaseState: AppBaseState = {
  showSidenavLarge: false,
  isSidenavOpen: true,
  isSidenavLockedOpen: true,
  isAlertBarOpen: false,
  isDowngradeBarOpen: false,
  isSessionExpiringPopupOpen: false,
  isTooltipPopupOpen: false,
  isAttachmentPopupOpen: false,
  messageCount: undefined,
  isRemoveUserFromOrganizationPopupOpen: false,
  isCancelOrgInvitePopupOpen: false,
  isOrgOwnerReassignmentPopupOpen: false,
  isOrgOwnerReassignment: false,
  isBmoWelcomePopupOpen: true,
  isBrandSpecificWelcomePopupOpen: true,
  isSendReceiptReminderPopupOpen: false,
  isCreateOrgIntegrationOpen: false,
  isManageOrgIntegrationPopupOpen: false,
  isCreateExpenseReportPopupOpen: false,
  isMarkExpenseReportsPaidPopupOpen: false,
  isDownloadExpenseReportsPaidPopupOpen: false,
  isDownloadSuccessPopupOpen: false,
  isDeleteExpensePopupOpen: false,
  isDeleteExpenseReportsPopupOpen: false,
  isDeactivateBudgetPopupOpen: false,
  isWhatsNewPopupOpen: false,
  isAcknowledgementAlertBarOpen: false,
  isSetupOrganizationPopupOpen: false,
  confirmOrgContinueLocation: undefined,
  isSubmitExpenseReportPopupOpen: false,
  isSyncTransactionsPopupOpen: false,
  isAddMissingInformationExpenseReportPopupOpen: false,
  isUploadReceiptsAutoMatchPopupOpen: false,
  isRemoveBudgetUserPopupOpen: false,
  isMobileWebPopupOpen: true,
  isRequestCompletedPopupOpen: false,
  isBulkDeactivateVirtualCardsPopupOpen: false,
  isBulkCloseVirtualCardsPopupOpen: false,
  isBulkUpdateVirtualCardsFlyoutOpen: false,
  isAddSecondaryEmailPopupOpen: false,
  isFiltersFlyoutOpen: false,
  confirmOrgExpenseReportDateChangePopupProps: undefined,
  isExtraVerificationPopupOpen: false,
  isChoose2faMethodPopupOpen: false,
  isAddDeptPopupOpen: false,
  isAPIKeyCreatedPopupOpen: false,
  isDeleteAPIKeyPopupOpen: false,
  isBrandRedirectPopupOpen: false,
}

export type BaseActions =
  | SetIsSidenavOpenAction
  | SetShowSidenavLargeAction
  | SetIsSidenavLockedOpenAction
  | SetIsDowngradeBarVisibleAction
  | SetIsSessionExpiringPopupOpenAction
  | SetIsTooltipPopupOpenAction
  | SetIsAttachmentPopupOpenAction
  | GetAlertStatusSuccessAction
  | SetIsCancelOrgInvitePopupOpenAction
  | SetIsCreateOrgIntegrationOpenAction
  | SetIsManageOrgIntegrationPopupOpenAction
  | SetIsOrgOwnerReassignmentPopupOpenAction
  | SetIsBmoWelcomePopupOpenAction
  | SetIsSendReceiptReminderPopupOpenAction
  | SetIsDeleteAccountPopupOpenAction
  | SetIsCreateExpenseReportPopupOpenAction
  | SetIsMarkExpenseReportsPaidPopupOpenAction
  | SetIsDeleteExpensePopupOpenAction
  | SetIsDeleteExpenseReportsPopupOpenAction
  | SetIsDownloadExpenseReportsPaidPopupOpenAction
  | SetIsWhatsNewPopupOpenAction
  | SetIsAcknowledgementAlertBarOpenAction
  | SetIsSyncTransactionsPopupOpenAction
  | SetIsSetupOrganizationPopupOpenAction
  | SetIsDownloadSuccessPopupOpenAction
  | SetIsSubmitExpenseReportPopupOpenAction
  | SetIsAddMissingInformationExpenseReportPopupOpenAction
  | SetIsUploadReceiptsAutoMatchPopupOpenAction
  | SetIsRemoveBudgetUserPopupOpenAction
  | SetIsMobileWebPopupOpenAction
  | SetIsRequestCompletedPopupOpenAction
  | SetIsBulkDeactivateVirtualCardsPopupOpenAction
  | SetIsBulkCloseVirtualCardsPopupOpenAction
  | SetIsBulkUpdateVirtualCardsFlyoutOpenAction
  | SetIsAddSecondaryEmailPopupOpenAction
  | GetBudgetRequestsActions
  | SetFiltersFlyoutOpenAction
  | SetConfirmOrgExpenseReportDateChangePopupAction
  | SetIsExtraVerificationPopupOpenAction
  | SetIsChoose2faMethodPopupOpenAction
  | SetIsAddDeptPopupOpenAction
  | SetIsAddAPIKeyPopupOpenAction
  | SetIsDeleteAPIKeyPopupOpenAction
  | SetIsBrandRedirectPopupOpenAction

const stringParser = (str: string): any | undefined => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return undefined
    // Return a default object, or null based on use case.
  }
}

const BaseAppReducer = (
  state = initialBaseState,
  action: BaseActions,
): AppBaseState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_ALERT_STATUS_SUCCESS: {
        const alertsBarIsOpen = action.payload.incidents.length > 0
        if (alertsBarIsOpen) {
          const incidentUpdates = action.payload.incidents[0].incident_updates
          const localeStr = incidentUpdates[incidentUpdates.length - 1].body
          const parsedStr = stringParser(localeStr)
          const userLocale = action.payload.locale
          draft.alertMessage = parsedStr?.[`${userLocale}`]
            ? parsedStr?.[`${userLocale}`]
            : action.payload.incidents[0].name
        } else {
          draft.alertMessage = ''
        }
        draft.isAlertBarOpen = alertsBarIsOpen
        draft.messageCount = action.payload.incidents.length
        return draft
      }
      case SET_DOWNGRADE_BAR_VISIBLE: {
        draft.isDowngradeBarOpen = action.payload.isDowngradeBarVisible
        return draft
      }
      case SET_IS_SIDENAV_OPEN: {
        draft.isSidenavOpen = action.payload.isSidenavOpen
        return draft
      }
      case SET_SHOW_SIDENAV_LARGE: {
        draft.showSidenavLarge = action.payload.showSidenavLarge
        return draft
      }
      case SET_IS_SIDENAV_LOCKED_OPEN: {
        draft.isSidenavLockedOpen = action.payload.isSidenavLockedOpen
        return draft
      }
      case SET_IS_SESSION_EXPIRING_POPUP_OPEN: {
        draft.isSessionExpiringPopupOpen =
          action.payload.isSessionExpiringPopupOpen
        return draft
      }
      case SET_IS_TOOLTIP_POPUP_OPEN: {
        draft.isTooltipPopupOpen = action.payload.isTooltipPopupOpen
        draft.tooltipPopupMessage = action.payload.tooltipPopupMessage
        return draft
      }
      case SET_IS_ATTACHMENT_POPUP_OPEN: {
        draft.isAttachmentPopupOpen = action.payload.isAttachmentPopupOpen
        draft.deleteAction = action.payload.deleteAction
        draft.attachment = action.payload.attachment
        return draft
      }
      case SET_IS_DELETE_ACCOUNT_POPUP_OPEN: {
        draft.isDeactivateBudgetPopupOpen =
          action.payload.isDeactivateBudgetPopupOpen
        return draft
      }
      case SET_IS_CANCEL_ORG_INVITE_POPUP_OPEN: {
        draft.isCancelOrgInvitePopupOpen =
          action.payload.isCancelOrgInvitePopupOpen
        return draft
      }
      case SET_IS_CREATE_ORG_INTEGRATION_POPUP_OPEN: {
        draft.isCreateOrgIntegrationOpen =
          action.payload.isCreateOrgIntegrationOpen
        draft.createOrgIntegrationIntegrationType =
          action.payload.integrationType
        return draft
      }
      case SET_IS_MANAGE_ORG_INTEGRATION_POPUP_OPEN: {
        draft.isManageOrgIntegrationPopupOpen =
          action.payload.isManageOrgIntegrationPopupOpen
        return draft
      }
      case SET_IS_ORG_OWNER_REASSIGNMENT_POPUP_OPEN: {
        draft.isOrgOwnerReassignmentPopupOpen =
          action.payload.isOrgOwnerReassignmentPopupOpen
        return draft
      }
      case SET_IS_BMO_WELCOME_POPUP_OPEN: {
        draft.isBmoWelcomePopupOpen = action.payload.isBmoWelcomePopupOpen
        draft.isBrandSpecificWelcomePopupOpen =
          action.payload.isBmoWelcomePopupOpen
        return draft
      }
      case SET_IS_SEND_RECEIPT_REMINDER_POPUP_OPEN: {
        draft.isSendReceiptReminderPopupOpen =
          action.payload.isSendReceiptReminderPopupOpen
        return draft
      }
      case SET_IS_CREATE_EXPENSE_REPORT_POPUP_OPEN: {
        draft.isCreateExpenseReportPopupOpen =
          action.payload.isCreateExpenseReportPopupOpen
        return draft
      }
      case SET_IS_MARK_EXPENSE_REPORTS_PAID_POPUP_OPEN: {
        draft.isMarkExpenseReportsPaidPopupOpen =
          action.payload.isMarkExpenseReportsPaidPopupOpen
        return draft
      }
      case SET_IS_DOWNLOAD_EXPENSE_REPORTS_PAID_POPUP_OPEN: {
        draft.isDownloadExpenseReportsPaidPopupOpen =
          action.payload.isDownloadExpenseReportsPaidPopupOpen
        return draft
      }
      case SET_IS_DOWNLOAD_SUCCESS_POPUP_OPEN: {
        draft.isDownloadSuccessPopupOpen =
          action.payload.isDownloadSuccessPopupOpen
        return draft
      }
      case SET_IS_WHATS_NEW_POPUP_OPEN: {
        draft.isWhatsNewPopupOpen = action.payload.isWhatsNewPopupOpen
        return draft
      }
      case SET_IS_ACKNOWLEDGEMENT_ALERT_BAR_OPEN: {
        draft.isAcknowledgementAlertBarOpen =
          action.payload.isAcknowledgementAlertBarOpen
        return draft
      }
      case SET_IS_SETUP_ORGANIZATION_POPUP_OPEN: {
        draft.isSetupOrganizationPopupOpen =
          action.payload.isSetupOrganizationPopupOpen
        draft.confirmOrgContinueLocation = action.payload.continueLocation
        return draft
      }
      case SET_IS_DELETE_EXPENSE_POPUP_OPEN: {
        draft.isDeleteExpensePopupOpen = action.payload.isDeleteExpensePopupOpen
        return draft
      }
      case SET_IS_DELETE_EXPENSE_REPORTS_POPUP_OPEN: {
        draft.isDeleteExpenseReportsPopupOpen =
          action.payload.isDeleteExpenseReportsPopupOpen
        return draft
      }
      case SET_IS_SUBMIT_EXPENSE_REPORT_POPUP_OPEN: {
        draft.isSubmitExpenseReportPopupOpen =
          action.payload.isSubmitExpenseReportPopupOpen
        return draft
      }
      case SET_IS_SYNC_TRANSACTIONS_POPUP_OPEN: {
        draft.isSyncTransactionsPopupOpen =
          action.payload.isSyncTransactionsPopupOpen
        return draft
      }
      case SET_IS_ADD_MISSING_INFORMATION_EXPENSE_REPORT_POPUP_OPEN: {
        draft.isAddMissingInformationExpenseReportPopupOpen =
          action.payload.isAddMissingInformationExpenseReportPopupOpen
        return draft
      }
      case SET_IS_UPLOAD_RECEIPTS_AUTO_MATCH_POPUP_OPEN: {
        draft.isUploadReceiptsAutoMatchPopupOpen =
          action.payload.isUploadReceiptsAutoMatchPopupOpen
        return draft
      }
      case SET_IS_REMOVE_BUDGET_USER_POPUP_OPEN: {
        draft.isRemoveBudgetUserPopupOpen =
          action.payload.isRemoveBudgetUserPopupOpen
        return draft
      }
      case SET_IS_REQUEST_COMPLETED_POPUP_OPEN: {
        draft.isRequestCompletedPopupOpen =
          action.payload.isRequestCompletedPopupOpen
        return draft
      }
      case SET_IS_ADD_DEPT_POPUP_OPEN: {
        draft.isAddDeptPopupOpen = action.payload.isAddDeptPopupOpen
        return draft
      }
      case SET_IS_MOBILE_WEB_POPUP_OPEN: {
        draft.isMobileWebPopupOpen = action.payload.isMobileWebPopupOpen
        return draft
      }
      case SET_IS_BULK_DEACTIVATE_VIRTUAL_CARDS_POPUP_OPEN: {
        draft.isBulkDeactivateVirtualCardsPopupOpen =
          action.payload.isBulkDeactivateVirtualCardsPopupOpen
        return draft
      }
      case SET_IS_BULK_CLOSE_VIRTUAL_CARDS_POPUP_OPEN: {
        draft.isBulkCloseVirtualCardsPopupOpen =
          action.payload.isBulkCloseVirtualCardsPopupOpen
        return draft
      }
      case SET_IS_BULK_UPDATE_VIRTUAL_CARDS_FLYOUT_OPEN: {
        draft.isBulkUpdateVirtualCardsFlyoutOpen =
          action.payload.isBulkUpdateVirtualCardsFlyoutOpen
        return draft
      }
      case SET_IS_ADD_SECONDARY_EMAIL_POPUP_OPEN: {
        draft.isAddSecondaryEmailPopupOpen =
          action.payload.isAddSecondaryEmailPopupOpen
        return draft
      }
      case SET_IS_FILTERS_FLYOUT_OPEN: {
        draft.isFiltersFlyoutOpen = action.payload.isFiltersFlyoutOpen
        return draft
      }
      case SET_CONFIRM_ORG_EXPENSE_REPORT_DATE_CHANGE_POPUP: {
        draft.confirmOrgExpenseReportDateChangePopupProps =
          action.payload.confirmOrgExpenseReportDateChangePopupProps
        return draft
      }
      case SET_IS_EXTRA_VERIFICATION_POPUP_OPEN: {
        draft.isExtraVerificationPopupOpen =
          action.payload.isExtraVerificationPopupOpen
        return draft
      }
      case SET_IS_CHOOSE_2FA_METHOD_POPUP_OPEN: {
        draft.isChoose2faMethodPopupOpen =
          action.payload.isChoose2faMethodPopupOpen
        return draft
      }
      case SET_IS_API_KEY_CREATED_POPUP_OPEN: {
        draft.isAPIKeyCreatedPopupOpen = action.payload.isAPIKeyCreatedPopupOpen
        draft.apiKeyCreatedAPIKey = action.payload.apiKey
        return draft
      }
      case SET_IS_DELETE_API_KEY_POPUP_OPEN: {
        draft.isDeleteAPIKeyPopupOpen = action.payload.isDeleteAPIKeyPopupOpen
        draft.deleteAPIKeyId = action.payload.apiKeyId
        draft.deleteAPIKeyExpiresAt = action.payload.expiry
        return draft
      }
      case SET_IS_BRAND_REDIRECT_POPUP_OPEN: {
        draft.isBrandRedirectPopupOpen = action.payload.isBrandRedirectPopupOpen
        return draft
      }
    }
  })
}

export type AppState = AppBaseState & {
  virtualCardDetail: VirtualCardDetailState
  transactionDetail: TransactionDetailState
  createVirtualCardForm: CreateVirtualCardState
  requestVirtualCard: RequestVirtualCardState
  updateVirtualCard: UpdateVirtualCardState
  account: AccountState
  resetPassword: ResetPasswordState
  createBudget: CreateBudgetState
  requestBudget: RequestBudgetState
  updateBudget: UpdateBudgetState
  profile: ProfileState
  manageOrgIntegration: ManageOrgIntegrationState
  signin: SigninState
  cspSignin: CspSigninState
  cspUserDetail: CspUserDetailState
  registerAccount: RegisterAccountState
  updateProfilePhoto: UpdateProfilePhotoState
  signup: SignupState
  deactivateVirtualCardContent: DeactivateVirtualCardContentState
  closeVirtualCardContent: CloseVirtualCardContentState
  closeAccountContent: CloseAccountContentState
  screenVirtualCard: ScreenVirtualCardState
  home: HomeState
  deleteAccount: DeactivateBudgetState
  downloadTransactions: DownloadTransactionsState
  transactions: TransactionsState
  profileSecurity: ProfileSecurityState
  search: SearchState
  notifications: NotificationsState
  accounts: AccountsState
  budgets: BudgetsState
  budget: BudgetState
  budgetRequest: BudgetRequestState
  people: PeopleState
  peopleDetail: PeopleDetailFlyoutState
  toast: ToastState
  organizationInvites: OrganizationInvitesState
  invitePeople: InvitePeopleState
  expenseReport: ExpenseReportState
  addExpense: AddExpenseState
  updateExpense: UpdateExpenseState
  organizationInfo: OrganizationInfoState
  businessRules: BusinessRulesState
  expenseReports: ExpenseReportsState
  createOrgIntegration: CreateOrgIntegrationState
  orgIntegration: OrgIntegrationsState
  receiptAutoMatch: ReceiptsAutoMatchState
  virtualCards: VirtualCardsState
  agent: AgentState
}

export const initialState: AppState = {
  ...initialBaseState,
  virtualCardDetail: initialVirtualCardDetailState,
  transactionDetail: initialTransactionDetailState,
  createVirtualCardForm: initialCreateVirtualCardState,
  requestVirtualCard: initialRequestVirtualCardState,
  updateVirtualCard: initialUpdateVirtualCardState,
  account: initialAccountState,
  budgets: initialBudgetsState,
  budget: initialBudgetState,
  budgetRequest: initialBudgetRequestState,
  resetPassword: initialResetPasswordState,
  createBudget: initialCreateBudgetState,
  requestBudget: initialRequestBudgetState,
  updateBudget: initialUpdateBudgetState,
  profile: initialProfileState,
  manageOrgIntegration: initialManageOrgIntegrationState,
  signin: initialSigninState,
  cspSignin: initialCspSigninState,
  cspUserDetail: initialCspUserDetailState,
  registerAccount: initialRegisterAccountState,
  updateProfilePhoto: initialUpdateProfilePhotoState,
  signup: initialSignupState,
  deactivateVirtualCardContent: initialDeactivateVirtualCardState,
  closeVirtualCardContent: initialCloseVirtualCardState,
  closeAccountContent: initialCloseAccountState,
  screenVirtualCard: initialScreenVirtualCardState,
  home: initialHomeState,
  deleteAccount: initialDeactivateBudgetState,
  downloadTransactions: initialDownloadTransactionsState,
  transactions: initialTransactionsState,
  profileSecurity: initialProfileSecurityState,
  search: initialSearchState,
  notifications: initialNotificationsState,
  accounts: initialAccountsState,
  people: initialPeopleState,
  peopleDetail: initialPeopleDetailFlyoutState,
  toast: initialToastState,
  organizationInvites: initialOrganizationInvitesState,
  invitePeople: initialInvitePeopleState,
  expenseReport: initialExpenseReportState,
  addExpense: initialAddExpenseState,
  updateExpense: initialUpdateExpenseState,
  organizationInfo: initialOrganizationInfoState,
  businessRules: initialBusinessRulesState,
  expenseReports: initialExpenseReportsState,
  createOrgIntegration: initialCreatOrgIntegrationState,
  orgIntegration: initialGetOrgIntegrationsState,
  receiptAutoMatch: initialReceiptsAutoMatchState,
  virtualCards: initialVirtualCardsState,
  agent: initialAgentState,
}

export type Actions =
  | ResetAppStateAction
  | BaseActions
  | VirtualCardDetailActions
  | TransactionDetailActions
  | CreateVirtualCardActions
  | RequestVirtualCardActions
  | UpdateVirtualCardActions
  | AccountActions
  | ResetPasswordActions
  | CreateBudgetActions
  | RequestBudgetActions
  | UpdateBudgetActions
  | ProfileActions
  | SigninActions
  | CspSigninActions
  | CspUserDetailActions
  | RegisterAccountActions
  | UpdateProfilePhotoActions
  | SignupActions
  | DeactivateVirtualCardActions
  | CloseVirtualCardActions
  | CloseAccountActions
  | ScreenVirtualCardActions
  | HomeActions
  | DeactivateBudgetActions
  | DownloadTransactionsActions
  | TransactionsActions
  | ProfileSecurityActions
  | SearchActions
  | AccountsActions
  | BudgetsActions
  | BudgetActions
  | PeopleActions
  | PeopleDetailActions
  | ToastActions
  | OrganizationInvitesActions
  | NotificationsActions
  | ExpenseReportActions
  | AddExpenseActions
  | UpdateExpenseActions
  | OrganizationInfoActions
  | BusinessRulesActions
  | ExpenseReportsActions
  | CreateOrgIntegrationActions
  | OrgIntegrationsActions
  | ReceiptsAutoMatchActions
  | VirtualCardsActions
  | AgentActions

const AppReducer = (state = initialState, action: Actions): AppState =>
  action.type === RESET_APP_STATE
    ? initialState
    : {
        ...BaseAppReducer(state, action as BaseActions),
        virtualCardDetail: VirtualCardDetailReducer(
          state.virtualCardDetail,
          action as VirtualCardDetailActions,
        ),
        transactionDetail: TransactionDetailReducer(
          state.transactionDetail,
          action as TransactionDetailActions,
        ),
        createVirtualCardForm: CreateVirtualCardFormReducer(
          state.createVirtualCardForm,
          action as CreateVirtualCardActions,
        ),
        requestVirtualCard: RequestVirtualCardReducer(
          state.requestVirtualCard,
          action as RequestVirtualCardActions,
        ),
        updateVirtualCard: UpdateVirtualCardReducer(
          state.updateVirtualCard,
          action as UpdateVirtualCardActions,
        ),
        account: AccountReducer(state.account, action as AccountActions),
        resetPassword: ResetPasswordReducer(
          state.resetPassword,
          action as ResetPasswordActions,
        ),
        createBudget: CreateBudgetReducer(
          state.createBudget,
          action as CreateBudgetActions,
        ),
        requestBudget: RequestBudgetReducer(
          state.requestBudget,
          action as RequestBudgetActions,
        ),
        updateBudget: UpdateBudgetReducer(
          state.updateBudget,
          action as UpdateBudgetActions,
        ),
        profile: ProfileReducer(state.profile, action as ProfileActions),
        manageOrgIntegration: ManageOrgIntegrationReducer(
          state.manageOrgIntegration,
          action as ManageOrgIntegrationActions,
        ),
        signin: SigninReducer(state.signin, action as SigninActions),
        cspSignin: CspSigninReducer(
          state.cspSignin,
          action as CspSigninActions,
        ),
        cspUserDetail: CspUserDetailReducer(
          state.cspUserDetail,
          action as CspUserDetailActions,
        ),
        registerAccount: RegisterAccountReducer(
          state.registerAccount,
          action as RegisterAccountActions,
        ),
        updateProfilePhoto: UpdateProfilePhotoReducer(
          state.updateProfilePhoto,
          action as UpdateProfilePhotoActions,
        ),
        signup: SignupReducer(state.signup, action as SignupActions),
        deactivateVirtualCardContent: DeactivateVirtualCardContentReducer(
          state.deactivateVirtualCardContent,
          action as DeactivateVirtualCardActions,
        ),
        closeVirtualCardContent: CloseVirtualCardContentReducer(
          state.closeVirtualCardContent,
          action as CloseVirtualCardActions,
        ),
        closeAccountContent: CloseAccountContentReducer(
          state.closeAccountContent,
          action as CloseAccountActions,
        ),
        screenVirtualCard: ScreenVirtualCardReducer(
          state.screenVirtualCard,
          action as ScreenVirtualCardActions,
        ),
        home: HomeReducer(state.home, action as HomeActions),
        deleteAccount: DeactivateBudgetReducer(
          state.deleteAccount,
          action as DeactivateBudgetActions,
        ),
        downloadTransactions: DownloadTransactionsReducer(
          state.downloadTransactions,
          action as DownloadTransactionsActions,
        ),
        transactions: TransactionsReducer(
          state.transactions,
          action as TransactionsActions,
        ),
        profileSecurity: ProfileSecurityReducer(
          state.profileSecurity,
          action as ProfileSecurityActions,
        ),
        search: SearchReducer(state.search, action as SearchActions),
        notifications: NotificationsReducer(
          state.notifications,
          action as NotificationsActions,
        ),
        accounts: AccountsReducer(state.accounts, action as AccountsActions),
        budgets: BudgetsReducer(state.budgets, action as BudgetsActions),
        budget: BudgetReducer(state.budget, action as BudgetActions),
        budgetRequest: BudgetRequestReducer(
          state.budgetRequest,
          action as BudgetRequestActions,
        ),
        people: PeopleReducer(state.people, action as PeopleActions),
        peopleDetail: PeopleDetailReducer(
          state.peopleDetail,
          action as PeopleDetailActions,
        ),
        toast: ToastReducer(state.toast, action as ToastActions),
        organizationInvites: OrganizationInvitesReducer(
          state.organizationInvites,
          action as OrganizationInvitesActions,
        ),
        invitePeople: InvitePeopleReducer(
          state.invitePeople,
          action as InvitePeopleActions,
        ),
        expenseReport: ExpenseReportReducer(
          state.expenseReport,
          action as ExpenseReportActions,
        ),
        addExpense: AddExpenseReducer(
          state.addExpense,
          action as AddExpenseActions,
        ),
        updateExpense: CoreUpdateExpenseReducer(
          state.updateExpense,
          action as UpdateExpenseActions,
        ),
        organizationInfo: OrganizationInfoReducer(
          state.organizationInfo,
          action as OrganizationInfoActions,
        ),
        businessRules: BusinessRulesReducer(
          state.businessRules,
          action as BusinessRulesActions,
        ),
        expenseReports: CoreExpenseReportsReducer(
          state.expenseReports,
          action as ExpenseReportsActions,
        ),
        createOrgIntegration: CreatOrgIntegrationReducer(
          state.createOrgIntegration,
          action as CreateOrgIntegrationActions,
        ),
        orgIntegration: OrgIntegrationReducer(
          state.orgIntegration,
          action as OrgIntegrationsActions,
        ),
        receiptAutoMatch: CoreReceiptsAutoMatchReducer(
          state.receiptAutoMatch,
          action as ReceiptsAutoMatchActions,
        ),
        virtualCards: VirtualCardsReducer(
          state.virtualCards,
          action as VirtualCardsActions,
        ),
        agent: AgentReducer(state.agent, action as AgentActions),
      }

export default AppReducer
